import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Radio from "@mui/material/Radio";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import KeyboardVoiceOutlinedIcon from "@mui/icons-material/KeyboardVoiceOutlined";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import RecordButton from "../../../Components/Media/RecordButton";
import AudioButton from "../../../Components/Media/AudioButton";
import Button from "@mui/material/Button";
import { unicodeToString } from "../../../Js/Common";
import SmartCheckCard from "../../../Components/Card/AssetUI/SmartCheckCard";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PauseIcon from "@mui/icons-material/Pause";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const REC = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [localAudios, setLocalAudios] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  let [smartCheckResult, setSmartCheckResult] = useState([]);
  let [isPlaying, setIsPlaying] = useState(false);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);
  let [unscripted, setUnscripted] = useState(false);
  let [currentRecord, setCurrentRecord] = useState(false);
  let [aiEnable, setAiEnable] = useState(true);

  // Redux state
  const {
    showAnswer,
    assetLogObj,
    attempted,
    currentAttempt,
    numberOfAttemptes,
    recordingContinueIndex,
    recordingAudioContinueIndex,
    attempedAnsLog,
    fromCompletedTab,
  } = useSelector((state) => state.currentAsset);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);

  useEffect(() => {
    if (props.content) {
      console.log("!!!!content", props.content);
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill(null)
      );
      setLocalAudios(
        new Array(props.content.epage.options.content.length).fill(null)
      );
      setCurrentIndexPlay(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      if (
        siteConfig?.customer?.addOnInfo?.isExpertSystem == undefined ||
        siteConfig?.customer?.addOnInfo?.isExpertSystem
      ) {
        if (
          props.content.epage.options?.ai_enable != undefined &&
          !fromCompletedTab
        ) {
          setAiEnable(props.content.epage.options.ai_enable);
          dispatch(
            currentAssetSliceActions.setAiEnable(
              props.content.epage.options.ai_enable
            )
          );
        }
      } else {
        setAiEnable(false);
        dispatch(currentAssetSliceActions.setAiEnable(false));
      }
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill(null)
        )
      );
      let actualAnswers = props.content.epage.options.content.map((val) => {
        if (val.text) return unicodeToString(val.text);
        else return "";
      });

      if (props.content.epage.options.unscripted_text) {
        setUnscripted(true);
      } else {
        setUnscripted(false);
      }
      setSmartCheckResult([]);

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content, siteConfig]);

  useEffect(() => {
    if (fromCompletedTab) {
      setAiEnable(false);
      dispatch(currentAssetSliceActions.setAiEnable(false));
    }
  }, [fromCompletedTab]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    setCurrentOptionIndex(0);
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill(null)
    );
    setLocalAudios(
      new Array(props.content.epage.options.content.length).fill(null)
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill(null)
      )
    );
    setCurrentOptionIndex(0);
  }, [currentAttempt]);

  useEffect(() => {
    console.log("showAnswer", showAnswer);
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
      let firstTrueIndex = assetLogObj.actualAnswer.indexOf(true);
      console.log("firstTrueIndex", firstTrueIndex);
      setCurrentOptionIndex(firstTrueIndex);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
      setLocalAudios([]);
      setSmartCheckResult([]);
      setUnscripted(false);
    };
  }, []);

  const updateUserAnswer = (flag) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      newArray[currentOptionIndex] = flag;
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setAudioLinks = (audioLink, index) => {
    let newArray = [...localAudios];
    newArray[index] = audioLink;
    setLocalAudios(newArray);
    if (userInfo.rolesInfo.title.toLowerCase() != "learner") {
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setSmartCheck = (result, filename, index) => {
    console.log("SFGGF", result, filename, index);
    if (result != "site_server") {
      if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
        let newArray = [...userAnswer];
        newArray[index] = filename;
        setUserAnswer(newArray);
        dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
      }
      console.log("filename", filename);
      let newArray = [...smartCheckResult];
      let updateFlag = true;
      if (
        newArray[index] &&
        !unscripted &&
        +newArray[index]["utterance"][0]["nativeness_score"] >
          result["utterance"][0]["nativeness_score"]
      ) {
        updateFlag = false;
      }

      newArray[index] = result;
      if (updateFlag && aiEnable) {
        dispatch(currentAssetSliceActions.setSmartCheckData(newArray));
      }
      console.log("newArray", newArray);
      setSmartCheckResult(newArray);
    } else {
      if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
        let newArray = [...userAnswer];
        newArray[index] = filename;
        setUserAnswer(newArray);
        dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
      }
    }
  };

  const setFiles = (filename, index) => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      let newArray = [...userAnswer];
      newArray[index] = filename;
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <div className={classes.scrollBar}>
      {props.content &&
        props.content.epage.options.content &&
        props.content.epage.options.content.map((val, index) => {
          return (
            <List
              dense
              sx={{
                borderBottom: 1,
                borderRadius: 10,
                borderBottomColor: "#EFEFEF",
                padding: 0,
                my: 2,
              }}
            >
              <ListItem sx={{ pa: 0 }}>
                {val && val.media && (
                  <OptionMedia
                    media={val.media}
                    isPlaying={currentIndexPlay[index]}
                    setPlayMode={(status, end) => {
                      setPlayMode(status, index, end);
                    }}
                    disabled={
                      recordingContinueIndex != -1 ||
                      recordingAudioContinueIndex != -1
                    }
                  ></OptionMedia>
                )}

                <ListItemText
                  classes={{ primary: classes.ListItemText }}
                  sx={{ color: "primary.main", pl: 1, pr: 1 }}
                >
                  {!val.hidetext && (
                    <Typography
                      sx={{
                        fontWeight: "500",
                        fontSize: "1rem",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                        },
                      }}
                    >
                      {val.text ? unicodeToString(val.text) : ""}
                    </Typography>
                  )}
                </ListItemText>

                <RecordButton
                  textToCheck={val.text ? unicodeToString(val.text) : ""}
                  alreadyRecorded={
                    localAudios.length > 0 && localAudios[index]
                      ? localAudios[index]
                      : null
                  }
                  recordedAudio={(audio) => {
                    setAudioLinks(audio, index);
                  }}
                  smartCheck={(data, filename) => {
                    setSmartCheck(data, filename, index);
                  }}
                  uploadedAudioName={(filename) => {
                    setFiles(filename, index);
                  }}
                  checkOnPause={aiEnable}
                  resetComponent={true}
                  numberOfAttemptes={
                    siteConfig.customer?.addOnInfo?.isSelfLearning && unscripted
                      ? 1
                      : numberOfAttemptes
                  }
                  unscripted={unscripted}
                  index={index}
                  disabled={
                    (recordingContinueIndex != -1 &&
                      recordingContinueIndex != index) ||
                    recordingAudioContinueIndex != -1 ||
                    attempedAnsLog ||
                    (userInfo.rolesInfo.title.toLowerCase() == "learner" &&
                      attempted)
                  }
                  audioDisable={
                    (recordingAudioContinueIndex != -1 &&
                      recordingAudioContinueIndex != index) ||
                    recordingContinueIndex != -1
                  }
                  disabledAll={currentIndexPlay.indexOf(true) > -1}
                ></RecordButton>
              </ListItem>
              {smartCheckResult &&
                smartCheckResult.length > 0 &&
                smartCheckResult[index] &&
                aiEnable && (
                  <ListItem sx={{ pa: 0, width: "100%" }}>
                    <ListItemText>
                      <SmartCheckCard
                        smartCheckResult={smartCheckResult[index]}
                        unscripted={unscripted}
                      ></SmartCheckCard>
                    </ListItemText>
                  </ListItem>
                )}
            </List>
          );
        })}
    </div>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#adbdff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#3751A8",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#adbdff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#3751A8",
      borderRadius: 5,
    },
  },
});
export default REC;
